import React, { useEffect } from "react"

import { graphql } from "gatsby"
import { ArticleQuoteFieldsFragment } from "../../../../../../graphql-types"

import * as styles from "./quote.module.scss"
import { elementOffset, transformItem } from "../../../functions/functions"
import { useLocale } from "../../../../../context/locale-context"

type QuoteProps = { data: ArticleQuoteFieldsFragment }

const Quote: React.FC<QuoteProps> = ({ data }) => {
  const { locale } = useLocale()

  const quoteLeft = locale === "fr" ? "« " : '"'
  const quoteRight = locale === "fr" ? " »" : '"'
  const displayQuote = quoteLeft + data.quote + quoteRight

  const handleScrollAnimation = () => {
    document.addEventListener("scroll", () => {
      const container = document.getElementsByClassName(styles.container)

      Array.from(container).forEach(artContainer => {
        if (window.scrollY >= elementOffset(artContainer).top - 700) {
          transformItem(artContainer.getElementsByClassName(styles.quote)[0], 400)
          transformItem(artContainer.getElementsByClassName(styles.infoContainer)[0], 800)
        }
      })
    })
  }

  useEffect(() => {
    handleScrollAnimation()
  }, [])

  return (
    <section className={styles.container}>
      {data.useImage && (
        <div className={styles.infoContainer}>
          {data.image && (
            <div className={styles.imageContainer}>
              <img src={data.image.url} alt={data.image.alt || ""} title={data.image.title} className={styles.image} />
            </div>
          )}
          <div className={styles.descriptionContainer}>
            <p className={styles.title}>{data.imageTitle}</p>
            <p className={styles.description}>{data.imageDescription}</p>
          </div>
        </div>
      )}
      <div className={styles.quoteContainer} style={{ marginLeft: data.useImage ? "0" : "auto" }}>
        <blockquote className={styles.quote}>{displayQuote}</blockquote>
      </div>
    </section>
  )
}

export const fragment = graphql`
  fragment ArticleQuoteFields on DatoCmsArticleQuote {
    __typename
    id
    quote
    useImage
    image {
      alt
      format
      title
      url
    }
    imageTitle
    imageDescription
  }
`

export default Quote
